import branding from 'shared/app/model/branding';
export function isGeozonesEnabled() {
    if (branding.geozones) {
        return true;
    }
    if (branding.geozones_in_paid_tariff) {
        return true;
    }
    return false;
}
